import {Milestone} from "../../milestone/MilestoneService";
import {LocalStorageService} from "../../../types/NgStorage";
import {IModalService} from "angular-ui-bootstrap";
import {MilestoneStore} from "../../milestone/MilestoneStore";
import {AccountStore} from "../../../account/store/AccountStore";
import {AccountBriefRecords} from "../../../account/types/AccountBriefRecord";
import {PortfolioType} from "../../../portfolio/models/Portfolio";

export class BrokerageOfferService {

    public static id = "ivBrokerageOfferService";

    /** @ngInject */
    public constructor(private readonly $localStorage: LocalStorageService,
                       private readonly $uibModal: IModalService,
                       private readonly accountStore: AccountStore,
                       private readonly milestoneStore: MilestoneStore) {
    }

    public async maybeShowIvBrokerageOffer() {
        this.accountStore
            .userAccounts
            .first()
            .filter((accounts) => this.hasNoBrokerAccount(accounts))
            .switchMap(() => this.milestoneStore.current.first())
            .map((m) => m.hasCompleted(Milestone.ACC_OPEN_STARTED))
            .filter((started) => !started)
            .subscribe(() => this.showIvBrokerageOffer());
    }

    private hasNoBrokerAccount(accounts: AccountBriefRecords): boolean {
        return accounts.every((a) => a.portfolioType !== PortfolioType.BROKER);
    }

    private showIvBrokerageOffer() {
        const modalOptions = {
            templateUrl: "app/offers/brokerageOffer/brokerageOffer.tpl.html",
            controller: "brokerageOfferCtrl as brokerageOfferCtrl",
            size: "lg",
            resolve: {}
        };
        this.$uibModal.open(modalOptions);
    }
}
